import interact from 'interactjs';

export function initializeResizer(resizableElement, resizeHandleElement, onChange, onStart, onEnd, columnSpacing, initialWidths) {

  resizableElement.style.cursor = 'default';

  const interactable = interact(resizableElement)
    .resizable({

      edges: {
        left: false,
        right: resizeHandleElement,
        bottom: false,
        top: false
      },

      listeners: {
        move: function moveListener(event) {

          const target = event.target;
          const container = target.parentNode;
          const handles = container.querySelectorAll('.column-width-resize-handle');
          const nextSibling = target.nextElementSibling;
          const deltaWidth = event.deltaRect.width;
          const containerWidth = container.offsetWidth;
          const gapTotalWidth = ((handles.length) * 5) + 2; // Total gap width

          if (!nextSibling) {
            return;
          }

          // Calculate new widths as percentages
          let targetNewWidth = ((target.offsetWidth + deltaWidth) / (containerWidth - gapTotalWidth)) * 100;
          let nextSiblingWidthDelta = (-deltaWidth / (containerWidth - gapTotalWidth)) * 100;
          let nextSiblingNewWidth = ((nextSibling.offsetWidth - deltaWidth) / (containerWidth - gapTotalWidth)) * 100;

          onChange({
            targetNewWidth,
            nextSiblingNewWidth,
            nextSiblingWidthDelta
          });

        }
      },
      modifiers: [
        // // keep the edges inside the parent
        // interact.modifiers.restrictEdges({
        //   outer: 'parent'
        // }),

        // minimum size
        interact.modifiers.restrictSize({
          min: { width: 100 }
        })
      ],

      inertia: true,
      cursorChecker() {
        // don't set a cursor for drag actions
        return null;
      }
    }).on(['resizestart'], function resizeStartHandler(event) {

      onStart();

      resizeHandleElement.classList.add('resizing');

    })
    .on(['resizestart', 'resizemove', 'resizeend'], function defaultPrevention(event) {
      event.preventDefault();
      event.stopPropagation();
    })
    .on(['resizeend'], function resizeEndHandler(event) {
      resizeHandleElement.classList.remove('resizing');
      if (onEnd) {
        onEnd();
      }
    }).draggable({
      listeners: { move: window.dragMoveListener },
      inertia: true,
      modifiers: [
        interact.modifiers.restrictRect({
          restriction: 'parent',
          endOnly: true
        })
      ],
      cursorChecker() {
        // don't set a cursor for drag actions
        return null;
      }
    });

  return function uninitialize() {
    interactable.unset();
  };

}